import { Link, useParams } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getNewsById, getRelatedNews } from "@/utils/media";

export default function NewsDetail() {
  const { id } = useParams();
  const item = id ? getNewsById(id) : undefined;

  usePageMeta(
    item ? `${item.title} - 影视资讯 - 茶杯狐影视` : "影视资讯 - 茶杯狐影视",
    item ? item.summary : "茶杯狐影视资讯详情页。",
  );

  if (!item) {
    return (
      <div className="mx-auto flex max-w-page flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-accent-600">
          <i className="ri-newspaper-line text-3xl" aria-hidden="true" />
        </span>
        <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">
          资讯不存在或已下线
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          这篇资讯可能已被移除，去看看其他影视动态吧。
        </p>
        <Link
          to="/news"
          className="mt-6 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = getRelatedNews(item, 3);

  return (
    <div className="w-full">
      <div className="mx-auto max-w-page px-4 py-8 md:px-6 md:py-10">
        <Link
          to="/news"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-700"
        >
          <i className="ri-arrow-left-line" aria-hidden="true" />
          返回资讯列表
        </Link>

        <article className="mx-auto mt-6 max-w-3xl">
          <div className="flex flex-wrap items-center gap-3">
            <span className="rounded-md bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
              {item.category}
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground-400">
              <i className="ri-calendar-line" aria-hidden="true" />
              {item.date}
            </span>
          </div>

          <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {item.title}
          </h1>

          <p className="mt-4 border-l-4 border-accent-400 bg-background-100/70 px-4 py-3 text-sm leading-relaxed text-foreground-700">
            {item.summary}
          </p>

          <div className="mt-6 w-full overflow-hidden rounded-lg" style={{ aspectRatio: "16 / 9" }}>
            <img
              src={item.cover}
              alt={`${item.title}配图`}
              title={item.title}
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="mt-6 flex flex-col gap-5">
            {item.content.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm leading-loose text-foreground-700 md:text-base"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2 border-t border-background-200 pt-5">
            <span className="text-xs text-foreground-400">相关标签：</span>
            {item.tags.map((tag) => (
              <span
                key={tag}
                className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900"
              >
                #{tag}
              </span>
            ))}
          </div>
        </article>

        {related.length > 0 ? (
          <section className="mx-auto mt-14 max-w-3xl">
            <h2 className="mb-5 flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <span className="flex h-8 w-1.5 rounded-full bg-accent-500" />
              相关文章推荐
            </h2>
            <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {related.map((rel) => (
                <Link
                  key={rel.id}
                  to={`/news/${rel.id}`}
                  className="group flex flex-col gap-1 p-4 transition-colors hover:bg-background-100"
                >
                  <div className="flex items-center gap-2">
                    <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                      {rel.category}
                    </span>
                    <span className="text-xs text-foreground-400">{rel.date}</span>
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                    {rel.title}
                  </h3>
                </Link>
              ))}
            </div>
          </section>
        ) : null}

        <div className="mx-auto mt-8 flex max-w-3xl">
          <Link
            to="/news"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-arrow-left-line" aria-hidden="true" />
            返回资讯列表
          </Link>
        </div>
      </div>
    </div>
  );
}